import styled from 'styled-components/macro'

export const SideFloat = styled.div`
  position: relative;
  float: left;
  height: 511px;
  width: 100%;
  margin-right: -46%;
  margin-top: 2rem;
  margin-bottom: 2rem;
  transform: translateX(calc(-46% - 30px));
  @media (max-width: 1280px) {
    float: none;
    margin-right: 0%;
    transform: translateX(0);
    height: auto;
  }
`
export const SideText = styled.div`
  position: relative;
  div {
    position: absolute;
    top: 0;
    width: calc(52rem + 2 * var(--spacing-sm));
    left: 54%;
  }
  @media (max-width: 1280px) {
    div {
      position: relative;
      left: auto;
      width: 100%;
    }
  }
`

export const ColoredTitle = styled.div`
  margin: auto;
  max-width: calc(100% - 2 * var(--spacing-sm));
  text-align: center;
  img {
    max-width: 100%;
  }
`
